import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_PROFESSORS = '[Professor] Get Professors',
  GET_PROFESSORS_SUCCESS = '[Professor] Get Professors Success',
  GET_PROFESSORS_FAILED = '[Professor] Get Professors Failed',

  GET_PROFESSORS_SUBJECTS = '[Professor] Get Professor Subjects',
  GET_PROFESSORS_SUBJECTS_SUCCESS = '[Professor] Get Professor Subjects Success',
  GET_PROFESSORS_SUBJECTS_FAILED = '[Professor] Get Professor Subjects Failed',

  GET_PROFESSOR_SUBJECT_WORK_ITEMS = '[Professor] Get Professor Subject Work Item',
  GET_PROFESSOR_SUBJECT_WORK_ITEMS_SUCCESS = '[Professor] Get Professor Subject Work Item Success',
  GET_PROFESSOR_SUBJECT_WORK_ITEMS_FAILED = '[Professor] Get Professor Subject Work Item Failed',

  ADD_PROFESSOR_SUBJECT_WORK_ITEM = '[Professor] Add Professor Subject Work Item',
  ADD_PROFESSOR_SUBJECT_WORK_ITEM_SUCCESS = '[Professor] Add Professor Subject Work Item Success',
  ADD_PROFESSOR_SUBJECT_WORK_ITEM_FAILED = '[Professor] Add Professor Subject Work Item Failed',

  UPDATE_PROFESSOR_SUBJECT_WORK_ITEM = '[Professor] Update Professor Subject Work Item',
  UPDATE_PROFESSOR_SUBJECT_WORK_ITEM_SUCCESS = '[Professor] Update Professor Subject Work Item Success',
  UPDATE_PROFESSOR_SUBJECT_WORK_ITEM_FAILED = '[Professor] Update Professor Subject Work Item Failed',

  GET_STUDENTS_WORK_ITEM_GRADE = '[Professor] Get Student Work Item Grades',
  GET_STUDENTS_WORK_ITEM_GRADE_SUCCESS = '[Professor] Get Student Work Item Grades Success',
  GET_STUDENTS_WORK_ITEM_GRADE_FAILED = '[Professor] Get Student Work Item Grades Failed',

  ENCODE_STUDENTS_WORK_ITEM_GRADE = '[Professor] Encode Student Work Item Grades',
  ENCODE_STUDENTS_WORK_ITEM_GRADE_SUCCESS = '[Professor] Encode Student Work Item Grades Success',
  ENCODE_STUDENTS_WORK_ITEM_GRADE_FAILED = '[Professor] Encode Student Work Item Grades Failed',

  GET_PROFESSOR_SUBJECT_STUDENTS = '[Professor] Get Professor Subject Students',
  GET_PROFESSOR_SUBJECT_STUDENTS_SUCCESS = '[Professor] Get Professor Subject Students Success',
  GET_PROFESSOR_SUBJECT_STUDENTS_FAILED = '[Professor] Get Professor Subject Students Failed',

  GET_GRADE_DETAILS = '[Professor] Get Grade Details',
  GET_GRADE_DETAILS_SUCCESS = '[Professor] Get Grade Details Success',
  GET_GRADE_DETAILS_FAILED = '[Professor] Get Grade Details Failed',
}

// Get Professors Actions
export const getProfessors = createAction(
  ActionTypes.GET_PROFESSORS
);

export const getProfessorsSuccess = createAction(
  ActionTypes.GET_PROFESSORS_SUCCESS,
  props<{ data: any }>()
);

export const getProfessorsFailed = createAction(
  ActionTypes.GET_PROFESSORS_FAILED,
  props<{ error: any }>()
);


/** Get Professor Subjects */
export const getProfessorSubjects = createAction(
  ActionTypes.GET_PROFESSORS_SUBJECTS
);
export const getProfessorSubjectsSuccess = createAction(
  ActionTypes.GET_PROFESSORS_SUBJECTS_SUCCESS,
  props<{ data: any }>()
);
export const getProfessorSubjectsFailed = createAction(
  ActionTypes.GET_PROFESSORS_SUBJECTS_FAILED,
  props<{ error: any }>()
);

/** Add Professor Subject Work Item */
export const addProfessorSubjectItem = createAction(
  ActionTypes.ADD_PROFESSOR_SUBJECT_WORK_ITEM,
  props<{ payload: any, subjectId: number }>()
);
export const addProfessorSubjectItemSuccess = createAction(
  ActionTypes.ADD_PROFESSOR_SUBJECT_WORK_ITEM_SUCCESS,
  props<{ data: any, message: string }>()
);
export const addProfessorSubjectItemFailed = createAction(
  ActionTypes.ADD_PROFESSOR_SUBJECT_WORK_ITEM_FAILED,
  props<{ message: string }>()
);

/** Update Professor Subject Work Item */
export const updateProfessorSubjectItem = createAction(
  ActionTypes.UPDATE_PROFESSOR_SUBJECT_WORK_ITEM,
  props<{ payload: any, subjectId: number, id: number }>()
);
export const updateProfessorSubjectItemSuccess = createAction(
  ActionTypes.UPDATE_PROFESSOR_SUBJECT_WORK_ITEM_SUCCESS,
  props<{ data: any, message: string }>()
);
export const updateProfessorSubjectItemFailed = createAction(
  ActionTypes.UPDATE_PROFESSOR_SUBJECT_WORK_ITEM_FAILED,
  props<{ message: string }>()
);

/** Get Professor Subject Work Items */
export const getProfSubjectWorkItems = createAction(
  ActionTypes.GET_PROFESSOR_SUBJECT_WORK_ITEMS,
  props<{ payload: any, subjectId: number }>()
);
export const getProfSubjectWorkItemsSuccess = createAction(
  ActionTypes.GET_PROFESSOR_SUBJECT_WORK_ITEMS_SUCCESS,
  props<{ data: any }>()
);
export const getProfSubjectWorkItemsFailed = createAction(
  ActionTypes.GET_PROFESSOR_SUBJECT_WORK_ITEMS_FAILED,
  props<{ message: string }>()
);

/** Get Work Item Students Grade */
export const getWorkItemStudentsGrade = createAction(
  ActionTypes.GET_STUDENTS_WORK_ITEM_GRADE,
  props<{
    subjectId: number,
    componentId: number,
    categoryId: number,
    workItemId: number
  }>()
);
export const getWorkItemStudentsGradeSuccess = createAction(
  ActionTypes.GET_STUDENTS_WORK_ITEM_GRADE_SUCCESS,
  props<{ data: any }>()
);
export const getWorkItemStudentsGradeFailed = createAction(
  ActionTypes.GET_STUDENTS_WORK_ITEM_GRADE_FAILED,
  props<{ error: string }>()
);

/** Get Work Item Students Grade */
export const encodeWorkItemStudentsGrade = createAction(
  ActionTypes.ENCODE_STUDENTS_WORK_ITEM_GRADE,
  props<{ payload: any, subjectGradeId: number }>()
);
export const encodeWorkItemStudentsGradeSuccess = createAction(
  ActionTypes.ENCODE_STUDENTS_WORK_ITEM_GRADE_SUCCESS,
  props<{ message: any }>()
);
export const encodeWorkItemStudentsGradeFailed = createAction(
  ActionTypes.ENCODE_STUDENTS_WORK_ITEM_GRADE_FAILED,
  props<{ error: string }>()
);

/** Get Professor Subject Students */
export const getProfSubjectStudents = createAction(
  ActionTypes.GET_PROFESSOR_SUBJECT_STUDENTS
);
export const getProfSubjectStudentsSuccess = createAction(
  ActionTypes.GET_PROFESSOR_SUBJECT_STUDENTS_SUCCESS,
  props<{ data: any }>()
);
export const getProfSubjectStudentsFailed = createAction(
  ActionTypes.GET_PROFESSOR_SUBJECT_STUDENTS_FAILED,
  props<{ error: any }>()
);

/** Get Grade Details */
export const getGradeDetails = createAction(
  ActionTypes.GET_PROFESSOR_SUBJECT_STUDENTS,
  props<{payload: any|null, subjectId: number}>()
);
export const getGradeDetailsSuccess = createAction(
  ActionTypes.GET_PROFESSOR_SUBJECT_STUDENTS_SUCCESS,
  props<{ data: any }>()
);
export const getGradeDetailsFailed = createAction(
  ActionTypes.GET_PROFESSOR_SUBJECT_STUDENTS_FAILED,
  props<{ error: any }>()
);